var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasContent)?_c(_vm.component,{tag:"component",staticClass:"cs-list",attrs:{"start":_vm.attrStart}},_vm._l((_vm.data),function(item,i){return _c('cs-text',{key:i,attrs:{"component":"li","data":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }